import { InitialDataAggregation, SupplierTestType } from 'model';
import { AsyncThunk, EntityId } from '@reduxjs/toolkit';
import {
  createAdapterSelectors,
  createEntitySlice,
  CustomThunk
} from '../../../redux/enitySlice';
import { supplierTestTypesThunk } from './test-types.thunk';
import { EntityAPI } from '../../../redux/entity-api.hook';
import { fetchInitialDataThunk } from '../../../redux/initial-data.thunk';

const { list, delete: deleteThunk, ...thunks } = supplierTestTypesThunk;

const supplierTestTypesSlice = createEntitySlice<SupplierTestType>(
  'test-types',
  [
    CustomThunk.override<SupplierTestType>(list, {
      pending: (_, state) => {
        state.state = 'pending';
        state.listFetched = undefined;
        state.error = null;
        return state;
      },
      rejected: (_, state, action) => {
        state.state = 'idle';
        state.listFetched = false;
        state.error = (action as any).error;
        return state;
      },
      fulfilled: (adapter, state, { payload }) => {
        state.state = 'idle';
        state.listFetched = true;
        return adapter.upsertMany(state, payload as SupplierTestType[]);
      }
    }),
    CustomThunk.override<any>(fetchInitialDataThunk, {
      pending: (_, state) => {
        return state;
      },
      rejected: (_, state) => {
        return state;
      },
      fulfilled: (adapter, state, { payload }) => {
        const dataPayload = payload as InitialDataAggregation;
        if (dataPayload.supplierTestTypes) {
          state.state = state.state === 'fresh' ? 'idle' : state.state;
          state.listFetched = true;
          return adapter.upsertMany(state, dataPayload.supplierTestTypes);
        }
        return state;
      }
    }),
    CustomThunk.override<SupplierTestType>(
      deleteThunk as AsyncThunk<EntityId, { id: EntityId }, any>,
      {
        fulfilled: (adapter, state, { payload }) => {
          state.state = 'idle';
          return adapter.removeOne(state, payload as string);
        }
      }
    ),
    ...Object.values(thunks)
  ]
);
export const supplierTestTypesSelectors = createAdapterSelectors(
  'test-types',
  supplierTestTypesSlice.adapter
);

export const testTypeAPI: EntityAPI<SupplierTestType> = {
  selectors: supplierTestTypesSelectors,
  thunks: supplierTestTypesThunk
};
export default supplierTestTypesSlice;
